import React from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  Divider,
  alpha,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Paper
} from '@mui/material';
import { 
  Business as BusinessIcon,
  ExpandMore as ExpandMoreIcon,
  Article as ArticleIcon,
  Info as InfoIcon,
  Code as CodeIcon
} from '@mui/icons-material';

const InformacoesEstabelecimento = ({ configuracoes, handleChange, customTheme }) => {
  return (
    <Box>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        mb: 2,
        color: customTheme.palette.primary.main
      }}>
        <BusinessIcon sx={{ mr: 1 }} />
        <Typography variant="h6" fontWeight={600}>
          Informações do Estabelecimento
        </Typography>
      </Box>
      
      <Divider sx={{ mb: 3 }} />
      
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Nome da Empresa"
            name="nomeEmpresa"
            value={configuracoes.nomeEmpresa}
            onChange={handleChange}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Endereço"
            name="enderecoEmpresa"
            value={configuracoes.enderecoEmpresa}
            onChange={handleChange}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Site/URL"
            name="siteEmpresa"
            value={configuracoes.siteEmpresa}
            onChange={handleChange}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Telefone"
            name="telefoneEmpresa"
            value={configuracoes.telefoneEmpresa}
            onChange={handleChange}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Mensagem Personalizada"
            name="mensagemExtra"
            value={configuracoes.mensagemExtra}
            onChange={handleChange}
            variant="outlined"
            size="small"
            helperText="Mensagem que aparecerá no rodapé do ticket"
          />
        </Grid>
      </Grid>
      
      <Box sx={{ mt: 3 }}>
        <Accordion 
          defaultExpanded={false} 
          sx={{ 
            '&:before': { display: 'none' },
            boxShadow: 'none',
            border: `1px solid ${alpha(customTheme.palette.divider, 0.2)}`,
            borderRadius: '8px !important',
            overflow: 'hidden'
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ 
              backgroundColor: alpha(customTheme.palette.primary.main, 0.03),
              '&:hover': {
                backgroundColor: alpha(customTheme.palette.primary.main, 0.05)
              }
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ArticleIcon 
                fontSize="small" 
                sx={{ 
                  mr: 1,
                  color: customTheme.palette.primary.main 
                }} 
              />
              <Typography variant="subtitle2" fontWeight={600}>
                Textos do Template
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
                  Personalize os textos fixos do template do ticket
                </Typography>
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Texto Preferencial"
                  name="textoPreferencial"
                  value={configuracoes.textoPreferencial || "ATENDIMENTO PREFERENCIAL"}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  helperText="Texto do rótulo de atendimento preferencial"
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Rótulo da Senha"
                  name="textoSenha"
                  value={configuracoes.textoSenha || "SENHA"}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  helperText="Texto que aparece acima do número da senha"
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Instrução 1"
                  name="instrucao1"
                  value={configuracoes.instrucao1 || "Aguarde o chamado da sua senha"}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Instrução 2"
                  name="instrucao2"
                  value={configuracoes.instrucao2 || "no painel eletrônico"}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              
              {configuracoes.incluirQrCode && (
                <>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Texto QR Code 1"
                      name="textoQrCode1"
                      value={configuracoes.textoQrCode1 || "Escaneie o QR Code"}
                      onChange={handleChange}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Texto QR Code 2"
                      name="textoQrCode2"
                      value={configuracoes.textoQrCode2 || "para acessar nosso site"}
                      onChange={handleChange}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
        
        <Accordion 
          defaultExpanded={false} 
          sx={{ 
            mt: 2,
            '&:before': { display: 'none' },
            boxShadow: 'none',
            border: `1px solid ${alpha(customTheme.palette.divider, 0.2)}`,
            borderRadius: '8px !important',
            overflow: 'hidden'
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ 
              backgroundColor: alpha(customTheme.palette.warning.main, 0.05),
              '&:hover': {
                backgroundColor: alpha(customTheme.palette.warning.main, 0.08)
              }
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <CodeIcon 
                fontSize="small" 
                sx={{ 
                  mr: 1,
                  color: customTheme.palette.warning.main 
                }} 
              />
              <Typography variant="subtitle2" fontWeight={600}>
                Variáveis Dinâmicas (Somente Leitura)
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" gutterBottom>
              Estas informações serão preenchidas automaticamente pelo sistema a cada ticket:
            </Typography>
            
            <Paper
              variant="outlined"
              sx={{ 
                mt: 1,
                p: 2,
                bgcolor: alpha(customTheme.palette.warning.main, 0.02)
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                    Variável
                  </Typography>
                  <Box sx={{ mb: 1 }}>
                    <Chip 
                      label="Tipo de Serviço" 
                      size="small" 
                      sx={{ mb: 1 }}
                      color="primary"
                      variant="outlined"
                    />
                  </Box>
                  <Box sx={{ mb: 1 }}>
                    <Chip 
                      label="Prefixo da Senha" 
                      size="small" 
                      sx={{ mb: 1 }}
                      color="primary"
                      variant="outlined"
                    />
                  </Box>
                  <Box sx={{ mb: 1 }}>
                    <Chip 
                      label="Número da Senha" 
                      size="small" 
                      sx={{ mb: 1 }}
                      color="primary"
                      variant="outlined"
                    />
                  </Box>
                  <Box sx={{ mb: 1 }}>
                    <Chip 
                      label="Data/Hora" 
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                    Exemplo
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    REGISTRO CIVIL
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    A
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    001
                  </Typography>
                  <Typography variant="body2">
                    08/05/2025 - 16:32
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
            
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Estas variáveis são preenchidas pelo sistema quando o ticket é gerado e não podem ser alteradas aqui.
              Você pode apenas customizar o estilo delas clicando nos elementos correspondentes no preview.
            </Typography>
          </AccordionDetails>
        </Accordion>
        
        <Accordion 
          defaultExpanded={false} 
          sx={{ 
            mt: 2,
            '&:before': { display: 'none' },
            boxShadow: 'none',
            border: `1px solid ${alpha(customTheme.palette.divider, 0.2)}`,
            borderRadius: '8px !important',
            overflow: 'hidden'
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ 
              backgroundColor: alpha(customTheme.palette.info.main, 0.03),
              '&:hover': {
                backgroundColor: alpha(customTheme.palette.info.main, 0.05)
              }
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <InfoIcon 
                fontSize="small" 
                sx={{ 
                  mr: 1,
                  color: customTheme.palette.info.main 
                }} 
              />
              <Typography variant="subtitle2" fontWeight={600}>
                Dicas para Impressão
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" sx={{ mb: 1.5 }}>
              Para obter o melhor resultado na impressão dos tickets:
            </Typography>
            <ul style={{ marginTop: 0, paddingLeft: '1.5rem' }}>
              <li>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Clique nos elementos no preview para personalizar os estilos (tamanhos, negrito, itálico).
                </Typography>
              </li>
              <li>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Textos muito longos podem ser cortados na impressão física, mantenha-os concisos.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Para testar a aparência real, use o botão "Imprimir Teste" após salvar as configurações.
                </Typography>
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Box>
  );
};

export default InformacoesEstabelecimento; 